<!-- Új illusztráció hozzáadása -->
<div class="add-new-illustration-container">
  <!-- Header -->
  <div class="page-header">
    <h1>Új illusztráció</h1>
    <div class="header-actions">
      <button mat-stroked-button type="button" (click)="goBack()" class="back-button">
        <mat-icon>arrow_back</mat-icon>
        Vissza
      </button>
      <button mat-raised-button color="primary" type="button" (click)="onSubmit()" [disabled]="!isAllFormsValid()" class="save-button">
        <mat-icon>save</mat-icon>
        Mentés
      </button>
    </div>
  </div>

  <!-- Stepper -->
  <mat-stepper #stepper class="illustration-stepper" linear>

    <!-- 1. lépés: Cég kiválasztása -->
    <mat-step [stepControl]="companyForm" label="Ügyfél kiválasztása">
      <form [formGroup]="companyForm" class="step-form">
        <!-- Cég kiválasztása -->
        <mat-card class="form-section">
          <mat-card-header>
            <mat-card-title>🏢 Ügyfél adatai</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="company-selector">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Válasszon ügyfelet</mat-label>
                <mat-select formControlName="selectedCompany" required (selectionChange)="onCompanySelected($event.value)">
                  @for (option of companyOptions; track option) {
                    <mat-option [value]="option">
                      {{option.display}}
                    </mat-option>
                  }
                </mat-select>
                @if (companyForm.get('selectedCompany')?.hasError('required')) {
                  <mat-error>
                    Kérjük válasszon ügyfelet
                  </mat-error>
                }
              </mat-form-field>
            </div>

            <!-- Kiválasztott cég/ügyfél adatai -->
            @if (companyForm.get('selectedCompany')?.value) {
              <div class="company-details">
                @if (companyForm.get('selectedCompany')?.value.type === 'company') {
                  <div class="company-info">
                    <h3>{{companyForm.get('selectedCompany')?.value.companyname}}</h3>
                    @if (companyForm.get('selectedCompany')?.value.companyregistrationnumber) {
                      <p><strong>Cégjegyzékszám:</strong> {{companyForm.get('selectedCompany')?.value.companyregistrationnumber}}</p>
                    }
                    @if (selectedCompanyDetails?.mainActivity) {
                      <p><strong>Fő tevékenység:</strong> {{selectedCompanyDetails.mainActivity}}</p>
                    }
                    @if ((selectedCompanyDetails?.existingCustomer !== undefined) || (selectedCompanyDetails?.existing_customer !== undefined) || (selectedCompanyDetails?.is_existing_customer !== undefined)) {
                      <p class="existing-customer-status">
                        @if (selectedCompanyDetails?.existingCustomer ?? selectedCompanyDetails?.existing_customer ?? selectedCompanyDetails?.is_existing_customer) {
                          <span class="existing-customer-yes">
                            <mat-icon color="primary" class="status-icon">check_circle</mat-icon>
                            Meglévő ügyfél
                          </span>
                        }
                        @if (!(selectedCompanyDetails?.existingCustomer ?? selectedCompanyDetails?.existing_customer ?? selectedCompanyDetails?.is_existing_customer)) {
                          <span class="existing-customer-no">
                            <mat-icon color="warn" class="status-icon">cancel</mat-icon>
                            Meglévő ügyfél
                          </span>
                        }
                      </p>
                    }
                    @if (selectedCompanyDetails?.relatedCustomers?.length) {
                      <p>
                        <strong>Kapcsolódó ügyfelek:</strong>
                        @for (c of selectedCompanyDetails.relatedCustomers; track c; let last = $last) {
                          <span>
                            {{c.fullName || c.fullname || c.name}}@if (!last) {
                            <span>, </span>
                          }
                        </span>
                      }
                    </p>
                  }
                </div>
              }
              @if (companyForm.get('selectedCompany')?.value.type === 'individual') {
                <div class="company-info">
                  <h3>{{companyForm.get('selectedCompany')?.value.fullname}}</h3>
                  @if (selectedCompanyDetails?.mainActivity) {
                    <p><strong>Fő tevékenység:</strong> {{selectedCompanyDetails.mainActivity}}</p>
                  }
                  @if ((selectedCompanyDetails?.existingCustomer !== undefined) || (selectedCompanyDetails?.existing_customer !== undefined) || (selectedCompanyDetails?.is_existing_customer !== undefined)) {
                    <p class="existing-customer-status">
                      @if (selectedCompanyDetails?.existingCustomer ?? selectedCompanyDetails?.existing_customer ?? selectedCompanyDetails?.is_existing_customer) {
                        <span class="existing-customer-yes">
                          <mat-icon color="primary" class="status-icon">check_circle</mat-icon>
                          Meglévő ügyfél
                        </span>
                      }
                      @if (!(selectedCompanyDetails?.existingCustomer ?? selectedCompanyDetails?.existing_customer ?? selectedCompanyDetails?.is_existing_customer)) {
                        <span class="existing-customer-no">
                          <mat-icon color="warn" class="status-icon">cancel</mat-icon>
                          Új ügyfél
                        </span>
                      }
                    </p>
                  }
                </div>
              }
            </div>
          }
        </mat-card-content>
      </mat-card>

      <div class="step-actions">
        <button mat-raised-button color="primary" matStepperNext [disabled]="!companyForm.valid">
          Következő
        </button>
      </div>
    </form>
  </mat-step>


  <!-- 2. lépés: Területek és ügyfelek -->
  <mat-step [stepControl]="areasClientsForm" label="Területek és ügyfelek">
    <form [formGroup]="areasClientsForm" class="step-form">

      <!-- Kiválasztott cég/ügyfél adatainak megjelenítése -->
      @if (companyForm.get('selectedCompany')?.value) {
        <div class="company-details">
          @if (companyForm.get('selectedCompany')?.value.type === 'company') {
            <div class="company-info">
              <h3>{{companyForm.get('selectedCompany')?.value.companyname}}</h3>
              @if (companyForm.get('selectedCompany')?.value.companyregistrationnumber) {
                <p><strong>Cégjegyzékszám:</strong> {{companyForm.get('selectedCompany')?.value.companyregistrationnumber}}</p>
              }
              @if (selectedCompanyDetails?.mainActivity) {
                <p><strong>Fő tevékenység:</strong> {{selectedCompanyDetails.mainActivity}}</p>
              }
              @if ((selectedCompanyDetails?.existingCustomer !== undefined) || (selectedCompanyDetails?.existing_customer !== undefined) || (selectedCompanyDetails?.is_existing_customer !== undefined)) {
                <p class="existing-customer-status">
                  @if (selectedCompanyDetails?.existingCustomer ?? selectedCompanyDetails?.existing_customer ?? selectedCompanyDetails?.is_existing_customer) {
                    <span class="existing-customer-yes">
                      <mat-icon color="primary" class="status-icon">check_circle</mat-icon>
                      Meglévő ügyfél
                    </span>
                  }
                  @if (!(selectedCompanyDetails?.existingCustomer ?? selectedCompanyDetails?.existing_customer ?? selectedCompanyDetails?.is_existing_customer)) {
                    <span class="existing-customer-no">
                      <mat-icon color="warn" class="status-icon">cancel</mat-icon>
                      Új ügyfél
                    </span>
                  }
                </p>
              }
              @if (selectedCompanyDetails?.relatedCustomers?.length) {
                <p>
                  <strong>Kapcsolódó ügyfelek:</strong>
                  @for (c of selectedCompanyDetails.relatedCustomers; track c; let last = $last) {
                    <span>
                      {{c.fullName || c.fullname || c.name}}@if (!last) {
                      <span>, </span>
                    }
                  </span>
                }
              </p>
            }
          </div>
        }
        @if (companyForm.get('selectedCompany')?.value.type === 'individual') {
          <div class="company-info">
            <h3>{{companyForm.get('selectedCompany')?.value.fullname}}</h3>
            @if (selectedCompanyDetails?.mainActivity) {
              <p><strong>Fő tevékenység:</strong> {{selectedCompanyDetails.mainActivity}}</p>
            }
            @if ((selectedCompanyDetails?.existingCustomer !== undefined) || (selectedCompanyDetails?.existing_customer !== undefined) || (selectedCompanyDetails?.is_existing_customer !== undefined)) {
              <p class="existing-customer-status">
                @if (selectedCompanyDetails?.existingCustomer ?? selectedCompanyDetails?.existing_customer ?? selectedCompanyDetails?.is_existing_customer) {
                  <span class="existing-customer-yes">
                    <mat-icon color="primary" class="status-icon">check_circle</mat-icon>
                    Meglévő ügyfél
                  </span>
                }
                @if (!(selectedCompanyDetails?.existingCustomer ?? selectedCompanyDetails?.existing_customer ?? selectedCompanyDetails?.is_existing_customer)) {
                  <span class="existing-customer-no">
                    <mat-icon color="warn" class="status-icon">cancel</mat-icon>
                    Új ügyfél
                  </span>
                }
              </p>
            }
          </div>
        }
      </div>
    }

    <!-- Területek és ügyfelek -->
    <mat-card class="form-section">
      <mat-card-header>
        <mat-card-title>👥 Területek és ügyfelek</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div formArrayName="areaClients">
          @for (areaClient of areaClientsArray.controls; track areaClient; let i = $index) {
            <div [formGroupName]="i" class="area-client-group">
              <mat-card class="area-card">
                <mat-card-header>
                  <mat-card-title>Terület {{i + 1}}</mat-card-title>
                  @if (areaClientsArray.length > 1) {
                    <button mat-icon-button type="button" (click)="removeAreaClient(i)" class="remove-button" color="warn">
                      <mat-icon>delete</mat-icon>
                    </button>
                  }
                </mat-card-header>
                <mat-card-content>
                  <!-- Terület kiválasztása -->
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Válasszon területet</mat-label>
                    <mat-select formControlName="area" required>
                      @for (area of areas; track area) {
                        <mat-option [value]="area">
                          {{area}}
                        </mat-option>
                      }
                    </mat-select>
                    @if (areaClient.get('area')?.hasError('required')) {
                      <mat-error>
                        Kérjük válasszon területet
                      </mat-error>
                    }
                  </mat-form-field>
                  <!-- Ügyfél kiválasztása vagy hozzáadása -->
                  <div class="client-selection">
                    <mat-form-field appearance="outline" class="client-select">
                      <mat-label>Válasszon ügyfelet</mat-label>
                      <mat-select formControlName="client" multiple (selectionChange)="onClientChange(i, $event.value)">
                        @for (customer of availableRelatedCustomers; track customer) {
                          <mat-option [value]="customer">
                            {{formatClientDisplay(customer)}}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    <app-add-new-button
                      text="Új ügyfél"
                      icon="person_add"
                      (clicked)="openNewClientDialog(i)"
                      [tooltip]="'Új ügyfél hozzáadása'"
                      class="new-client-button">
                    </app-add-new-button>
                  </div>
                  <!-- Kiválasztott ügyfél adatai -->
                  @if (areaClient.get('client')?.value?.length > 0) {
                    <div class="client-details">
                      <h4>Ügyfél adatai</h4>
                      <div class="client-info">
                        <p><strong>Név:</strong>
                        @for (client of areaClient.get('client')?.value; track client; let last = $last) {
                          <span>
                            {{client.fullName || client.fullname || client.name}}@if (client.birthDate) {
                            <span> ({{(client.birthDate | date:'yyyy.MM.dd')}})</span>
                            }@if (!last) {
                            <span>, </span>
                          }
                        </span>
                      }
                    </p>
                    @if (areaClient.get('client')?.value.birthDate) {
                      <p><strong>Születési dátum:</strong> {{areaClient.get('client')?.value.birthDate | date:'yyyy.MM.dd'}}</p>
                    }
                    @if (areaClient.get('client')?.value.emails?.[0]?.email || areaClient.get('client')?.value.email) {
                      <p><strong>Email:</strong> {{areaClient.get('client')?.value.emails?.[0]?.email || areaClient.get('client')?.value.email}}</p>
                    }
                    @if (areaClient.get('client')?.value.phones?.[0]?.phone || areaClient.get('client')?.value.phone) {
                      <p><strong>Telefon:</strong> {{areaClient.get('client')?.value.phones?.[0]?.phone || areaClient.get('client')?.value.phone}}</p>
                    }
                    @if (areaClient.get('client')?.value.address) {
                      <p><strong>Cím:</strong> {{areaClient.get('client')?.value.address}}</p>
                    }
                  </div>
                </div>
              }
              <!-- Megjegyzések -->
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Megjegyzések</mat-label>
                <input matInput formControlName="notes" placeholder="Írja ide a megjegyzéseit...">
                <mat-hint>Opcionális megjegyzések ehhez a területhez</mat-hint>
              </mat-form-field>
              <!-- Díjkezelés -->
              <div class="fees-section">
                <h4 class="section-title">💰 Díjak</h4>
                <!-- Új díj hozzáadása -->
                <div class="add-fee-container">
                  <mat-form-field appearance="outline" class="fee-amount">
                    <mat-label>Összeg</mat-label>
                    <input matInput type="number" formControlName="newFeeAmount" placeholder="25000">
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="fee-currency">
                    <mat-label>Pénznem</mat-label>
                    <mat-select formControlName="newFeeCurrency">
                      <mat-option value="HUF">HUF (Ft)</mat-option>
                      <mat-option value="USD">USD ($)</mat-option>
                      <mat-option value="EUR">EUR (€)</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <button mat-icon-button color="primary" type="button" (click)="addFee(i)"
                    [disabled]="!areaClient.get('newFeeAmount')?.value || !areaClient.get('newFeeCurrency')?.value" class="add-fee-button">
                    <mat-icon>add_circle</mat-icon>
                  </button>
                </div>
                <!-- Hozzáadott díjak megjelenítése -->
                @if (areaFees[i] && areaFees[i].length > 0) {
                  <div class="fees-display">
                    <mat-chip-set>
                      @for (fee of areaFees[i]; track fee; let feeIndex = $index) {
                        <mat-chip
                          [removable]="true" (removed)="removeFee(i, feeIndex)" class="fee-chip">
                          {{formatFee(fee)}}
                          <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                      }
                    </mat-chip-set>
                  </div>
                }
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      }
    </div>

    <!-- Add új terület gomb -->
    <div class="add-area-container">
      <button mat-fab color="primary" type="button" (click)="addAreaClient()" class="add-area-fab"
        matTooltip="Új terület hozzáadása"
        matTooltipPosition="left">
        <mat-icon>add</mat-icon>
      </button>
    </div>
  </mat-card-content>
</mat-card>

<div class="step-actions has-previous">
  <button mat-stroked-button matStepperPrevious>Előző</button>
  <button mat-raised-button color="primary" matStepperNext [disabled]="!isStep2Valid()">
    Következő
  </button>
</div>
</form>
</mat-step>

<!-- 3. lépés: További beállítások -->
<mat-step [stepControl]="additionalSettingsForm" label="További beállítások">
  <form [formGroup]="additionalSettingsForm" class="step-form">
    <mat-card class="form-section additional-settings-card">
      <mat-card-header>
        <mat-card-title>További beállítások</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Kiküldés dátuma</mat-label>
          <input matInput [matDatepicker]="sendDatePicker" formControlName="sendDate">
          <mat-datepicker-toggle matSuffix [for]="sendDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #sendDatePicker></mat-datepicker>
        </mat-form-field>
      </mat-card-content>
    </mat-card>

    <div class="step-actions only-previous">
      <button mat-stroked-button matStepperPrevious>Előző</button>
    </div>
  </form>
</mat-step>

</mat-stepper>
</div>


